/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UnFormalizedZipResponseDto = {
    /**
     * ID записи
     */
    id: number;
    /**
     * ID двигателя
     */
    engineId: number;
    /**
     * Код заказа
     */
    orderCode: string;
    /**
     * Серийный номер двигателя
     */
    serialNumber: string;
    /**
     * Фамилия и Имя
     */
    ownerName: string;
    /**
     * Компания
     */
    company: string;
    /**
     * Описание запроса
     */
    description?: string;
    /**
     * UUID документа
     */
    docUrlUuids?: Array<string>;
    /**
     * Статус запроса
     */
    status: UnFormalizedZipResponseDto.status;
    /**
     * Дата создания
     */
    createdAt: string;
    /**
     * Дата обновления
     */
    updatedAt: string;
};

export namespace UnFormalizedZipResponseDto {

    /**
     * Статус запроса
     */
    export enum status {
        NEW = 'NEW',
        COMPLETED = 'COMPLETED',
    }


}

